angular.module('zc.zenclerkS')
  .component('zcsProjectsWithoutCampaign', {
    templateUrl: '/templates/zenclerk_s/directives/projects_without_campaign/projects_without_campaign.html',
    bindings: {
      projects: '='
    },
    controllerAs: 'vm',
    controller: ZcsProjectsWithoutCampaignController,
  });


ZcsProjectsWithoutCampaignController.$inject = ['$scope', 'Campaign'];
function ZcsProjectsWithoutCampaignController($scope, Campaign) {
  const vm = this;

  $scope.$watch('vm.projects', activate);

  function activate() {
    _.map(vm.projects, project => {
      Campaign.all({projectId: project.id}).then(campaigns => {
        project.activeCampaigns = _.chain(campaigns)
          .filter(campaign => moment().isBefore(moment(campaign.end_at)) && campaign.status === 'activated')
          .value();

        project.lastEndedCampaign = _.chain(campaigns)
          .filter(campaign => moment().isAfter(moment(campaign.end_at)))
          .sort(campaign => -moment(campaign.end_at).valueOf())
          .head()
          .value();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/projects_without_campaign/projects_without_campaign.directive.js